export default __webpack_public_path__ + "static/char-s-07-kr-e2a128e2c5f0764baf67776bc5620089.webp";